export enum SearchCluster {
  all = 'all',
  product = 'product',
  supplier = 'supplier',
  category = 'category',
}
